import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimelineComponent = _resolveComponent("TimelineComponent")!
  const _component_ParticipantModal = _resolveComponent("ParticipantModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_TimelineComponent, {
        caption: "Activity",
        baseDate: _ctx.baseDate,
        showWeek: _ctx.showWeek,
        rowGroupHeaders: _ctx.rowGroupHeaders,
        rowHeaders: _ctx.rowHeaders,
        eventData: _ctx.elmtData,
        showBeforeToday: true,
        onClickRow: _ctx.onOpenModal,
        onUpdateBasedate: _ctx.updateTheFirstDate
      }, null, 8, ["baseDate", "showWeek", "rowGroupHeaders", "rowHeaders", "eventData", "onClickRow", "onUpdateBasedate"])
    ]),
    _createVNode(_component_ParticipantModal, {
      showModal: _ctx.showModal,
      onModalClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = $event)),
      eventColor: _ctx.stringColor(_ctx.modalEventHeaderId, false),
      eventID: _ctx.modalEventHeaderId,
      statusHeaders: _ctx.eventStatusHeaders
    }, null, 8, ["showModal", "eventColor", "eventID", "statusHeaders"])
  ], 64))
}